export default __webpack_public_path__ + "static/media/iccrr-logo.765963af.png";